import { MaterialService } from './material.service';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { Router } from '@angular/router';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Country } from '../model/country.model';
import { Certification, CertificationList } from '../model/certification.model';

@Injectable()
export class CertificationService extends KiwixiService {
  apiUpcoming = environment.server + 'certifications/';

  constructor(
    private _http: HttpClient,
    private _router: Router,
    kiwixiGlobals: KiwixiGlobals,
    private materialService: MaterialService,) {
    super(_http, _router, kiwixiGlobals, materialService);
  }

  getCertifications(params?: HttpParams): Observable<CertificationList> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<CertificationList>(this.apiUpcoming, {
      headers: header,
      params: params,
    }).
      pipe(
        catchError(this.handleErrorObservable<CertificationList>(`getcertifications`))
      );
  }

  getCertificationsWithUrl(_url): Observable<Certification[]> {
    const header = this.createHttpClientAuthorizationHeader();
    return this._http.get<Certification[]>(_url, {
      headers: header
    }).
      pipe(
        catchError(this.handleErrorObservable<Certification[]>(`getcertificationsWithUrl`))
      );
  }

  /**
   * Récupère la dernière certification active pour une langue et une date donnée.
   * Reproduit côté front la logique de Certification.get_last_certification() du backend.
   * @param languageId ID de la langue
   * @param date Date au format YYYY-MM-DD (validity_date <= date <= expiration_date)
   * @returns Observable<Certification | null>
   */
  getLastCertificationForLanguage(languageId: number, date: string): Observable<Certification | null> {
    const params = new HttpParams()
      .set('language', languageId.toString())
      .set('active', 'true')
      .set('validity_date__lte', date)
      .set('expiration_date__gte', date)
      .set('ordering', 'expiration_date');
    return this.getCertifications(params).pipe(
      map(result => {
        if (result?.results?.length > 0) {
          return result.results[result.results.length - 1];
        }
        return null;
      }),
      catchError(() => of(null))
    );
  }
}

